import { render } from "./messagesOfTheDay.vue?vue&type=template&id=0894d0bf&ts=true"
import script from "./messagesOfTheDay.vue?vue&type=script&lang=ts"
export * from "./messagesOfTheDay.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__